import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { FormSelect } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FormSelect.tsx';
import { useFlexiForwardPropertyChangedHandler } from '@/store/flexi-forward/hooks/useFlexiForwardPropertyChangedHandler.ts';

export function CutOffMarketField({ tileId }: { tileId: string }): ReactElement {
  const { possibleCutOffMarketPlaces, selectedCutOffMarketPlaces } = useFlexiForwardSelector((flexiForward) => ({
    possibleCutOffMarketPlaces: flexiForward.properties.possibleCutOffMarketPlaces?.possible ?? [],
    selectedCutOffMarketPlaces:
      flexiForward.properties.cutOffMarketPlace ?? flexiForward.properties?.possibleCutOffMarketPlaces?.default ?? '',
  }));

  const handleCutOffMarketChanged = useFlexiForwardPropertyChangedHandler<string>(
    tileId,
    'Cut Off Market change',
    (cutOffMarketPlace) => ({ cutOffMarketPlace }),
  );

  return (
    <FlexiForwardFormField formattedMessageId="flexiForwardTile.mainFields.cutOffMarket.label">
      <FormSelect<string>
        values={possibleCutOffMarketPlaces}
        selectedValue={selectedCutOffMarketPlaces ?? ''}
        onChange={handleCutOffMarketChanged}
        data-e2e="cut-off-marketplace-select"
      />
    </FlexiForwardFormField>
  );
}
